import { useStore } from '../lib/store.js';

export function V2BranchHeader({ channelID, threadURN }) {
  const activeBranchId = useStore(
    s => s.branchesByChannel[channelID]?.currentByThread?.get(threadURN) ?? null
  );
  const branch = useStore(
    s => activeBranchId
      ? s.branchesByChannel[channelID]?.branches?.get(activeBranchId)
      : null
  );
  const selectBranch = useStore(s => s.selectBranch);
  // JOBE-0142.6: show an empty-state callout when stale (pre-server) branches
  // were detected at hydration time. These branches can't be promoted automatically
  // and are dropped from in-memory state.
  const hasStaleLocalBranches = useStore(s => s.hasStaleLocalBranches);

  if (hasStaleLocalBranches && !activeBranchId) {
    return (
      <div className="v2-branch-header v2-branch-stale-notice" data-testid="v2-branch-stale-notice">
        Your local branches from a previous session can&#39;t be promoted automatically.
        Start a new branch to save it across devices.
      </div>
    );
  }

  if (!activeBranchId || !branch) return null;

  const displayTitle = branch.userTitle ?? branch.archivistTitle ?? branch.title;

  return (
    <div className="v2-branch-header" data-testid="v2-branch-header">
      <span className="v2-branch-label">
        Branch: <strong>{displayTitle}</strong>
      </span>
      {branch.fromMsgID && (
        <span className="v2-branch-origin"> · branched from msg {branch.fromMsgID}</span>
      )}
      <button
        type="button"
        className="v2-branch-back"
        data-testid="v2-branch-back"
        onClick={() => selectBranch({ channelID, threadURN, branchId: null })}
      >
        ← main
      </button>
    </div>
  );
}
